var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActivityWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.74941 6.24984C6.74941 5.5466 6.67993 4.73493 7.37441 4.33397C7.66447 4.1665 8.05389 4.1665 8.83273 4.1665H9.66606C10.4449 4.1665 10.8343 4.1665 11.1244 4.33397C11.8189 4.73493 11.7494 5.5466 11.7494 6.24984C11.7494 6.95308 11.8189 7.76475 11.1244 8.1657C10.8343 8.33317 10.4449 8.33317 9.66606 8.33317H8.83273C8.05389 8.33317 7.66447 8.33317 7.37441 8.1657C6.67993 7.76475 6.74941 6.95308 6.74941 6.24984Z",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.74941 13.7498C6.74941 13.0466 6.67993 12.2349 7.37441 11.834C7.66447 11.6665 8.05389 11.6665 8.83273 11.6665H14.6661C15.4449 11.6665 15.8343 11.6665 16.1244 11.834C16.8189 12.2349 16.7494 13.0466 16.7494 13.7498C16.7494 14.4531 16.8189 15.2648 16.1244 15.6657C15.8343 15.8332 15.4449 15.8332 14.6661 15.8332H8.83273C8.05389 15.8332 7.66447 15.8332 7.37441 15.6657C6.67993 15.2648 6.74941 14.4531 6.74941 13.7498Z",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.41414 1.6665V18.3332",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivityWhite);
export default __webpack_public_path__ + "static/media/activity-white.6fd4a5b15f799bd5918b24067f71b0be.svg";
export { ForwardRef as ReactComponent };